"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.parseIter = void 0;
const util_1 = require("./util");
function parseIter(arr) {
    const line = util_1.getFirstNonEmptyLine(arr);
    if (!line)
        throw new Error("Empty file received");
    const header = util_1.parseHeader(line);
    const res = util_1.parseBlocks(arr);
    if (res === undefined)
        throw new Error("No blocks parsed");
    const alns = res.seqs.map((n, index) => ({ id: res.ids[index], seq: n }));
    const { consensus } = res;
    if (consensus.length != alns[0].seq.length) {
        throw new Error(`Consensus length != sequence length. Con ${consensus.length} seq ${alns[0].seq.length}`);
    }
    return { consensus, alns, header };
}
exports.parseIter = parseIter;
function parse(contents) {
    const iter = contents.split("\n")[Symbol.iterator]();
    return parseIter(iter);
}
exports.parse = parse;
